var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customer-home",attrs:{"id":"rootDom"}},[_c('Header',{attrs:{"info_phone":_vm.info_phone,"userInfo":_vm.userInfo}}),_c('NavBar'),_c('Banner'),_c('main',{staticClass:"customer-main",class:{ moveUp: _vm.isMoveUp, moveDown: !_vm.isMoveUp }},[_c('router-view')],1),_c('Footer',{on:{"emitInfoPhone":_vm.getInfoPhone}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }